(function () {
  var b = document.getElementById('burger');
  var m = document.getElementById('menu-panel');
  if (b && m) {
    /* 14-oct-2026: el panel se cortaba abajo en celular ("no baja todo, la
       gente no alcanza a ver Rastrear mi pedido"). Causa: el CSS le daba
       max-height: 100dvh - 62px, pero el panel cuelga del encabezado y el
       encabezado NO esta en el borde de arriba cuando la pagina esta al
       inicio: lo empuja la barra de anuncios (~42px). Esos ~42px del panel
       quedaban debajo del borde de la pantalla y el scroll interno "llegaba
       al final" sin mostrarlos. Ahora el alto se mide: desde donde termina
       el encabezado hasta el borde de abajo de la ventana, y se vuelve a
       medir si la pagina se mueve o gira. */
    var nav = b.closest('.nav');
    function medirMenu() {
      if (!m.classList.contains('abierta') || !nav) { m.style.maxHeight = ''; return; }
      var tope = nav.getBoundingClientRect().bottom;
      var alto = Math.max(200, Math.floor(window.innerHeight - tope));
      m.style.maxHeight = alto + 'px';
    }
    b.addEventListener('click', function () {
      var abierto = m.classList.toggle('abierta');
      b.classList.toggle('abierto', abierto);
      b.setAttribute('aria-expanded', String(abierto));
      medirMenu();
    });
    window.addEventListener('resize', medirMenu);
    window.addEventListener('scroll', medirMenu, { passive: true });
    m.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        m.classList.remove('abierta');
        b.classList.remove('abierto');
        b.setAttribute('aria-expanded', 'false');
        medirMenu();
      }
    });
    document.addEventListener('click', function (e) {
      if (m.classList.contains('abierta') && !e.target.closest('.nav')) {
        m.classList.remove('abierta');
        b.classList.remove('abierto');
        b.setAttribute('aria-expanded', 'false');
        medirMenu();
      }
    });
  }

  var principal = document.getElementById('img-principal');
  if (principal) {
    document.querySelectorAll('.producto__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        principal.src = t.getAttribute('data-src');
      });
    });
  }

  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  // popup + boton flotante + contador de 24h del descuento
  var popup = document.getElementById('popup');
  var fab = document.getElementById('fab-descuento');
  var fabLabel = document.getElementById('fab-label');
  var ACT_KEY = 'xc_desc_activado';
  var DUR = 24 * 60 * 60 * 1000;

  function dos(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms) {
    var h = Math.floor(ms / 3600000);
    var mi = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    return dos(h) + ':' + dos(mi) + ':' + dos(s);
  }
  function getT0() { try { return parseInt(localStorage.getItem(ACT_KEY) || '0', 10); } catch (e) { return 0; } }

  // si el popup se envio con exito, guardar el momento de activacion (una sola vez)
  if (popup && popup.hasAttribute('data-exito') && !getT0()) {
    try { localStorage.setItem(ACT_KEY, String(Date.now())); } catch (e) {}
  }

  function tick() {
    var t0 = getT0();
    var cont = document.getElementById('popup-contador');
    if (!t0) return false;
    var rem = t0 + DUR - Date.now();
    if (rem > 0) {
      var txt = fmt(rem);
      if (cont) { cont.textContent = txt; cont.classList.remove('vencido'); }
      if (fabLabel) fabLabel.textContent = 'Descuento · ' + txt;
      return false;
    } else {
      if (cont) { cont.textContent = 'Tu descuento ha expirado'; cont.classList.add('vencido'); }
      if (fabLabel) fabLabel.textContent = 'Descuento';
      return true;
    }
  }
  if (getT0()) {
    if (!tick()) { var iv = setInterval(function () { if (tick()) clearInterval(iv); }, 1000); }
  }

  if (popup) {
    var CLAVE = 'xc_ruleta_v1'; /* 22-oct-2026: popup nuevo (ruleta 5%), se vuelve a mostrar una vez a quien cerro el viejo */
    var abrir = function () { popup.hidden = false; document.body.classList.add('sin-scroll'); };
    var cerrar = function () {
      popup.hidden = true;
      document.body.classList.remove('sin-scroll');
      try { localStorage.setItem(CLAVE, '1'); } catch (e) {}
    };
    popup.querySelectorAll('[data-cerrar]').forEach(function (el) { el.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) cerrar(); });

    if (fab) {
      fab.addEventListener('click', function () {
        var t0 = getT0();
        var rem = t0 ? t0 + DUR - Date.now() : 0;
        if (t0 && rem > 0) {
          window.location.href = fab.getAttribute('data-discount-url');
        } else {
          abrir();
        }
      });
    }

    if (popup.hasAttribute('data-exito')) {
      abrir();
    } else {
      var visto = null;
      try { visto = localStorage.getItem(CLAVE); } catch (e) {}
      if (!visto && !getT0()) {
        // 7-oct-2026: el popup YA tenia espera de 18s, pero el disparador de
        // scroll a 650px lo anulaba: en celular eso es menos de una pantalla,
        // asi que con un deslizon salia casi de inmediato. Por eso se sentia
        // instantaneo aunque el temporizador dijera 18s.
        // Ahora hay un PISO de tiempo: pase lo que pase, nunca antes de 12s.
        // Y el scroll se subio a 1400px (ya paso el hero y el carrusel).
        var T0_VISITA = Date.now();
        var PISO = 12000;
        var lanzado = false;
        var tid = null;
        var limpiar = function () {
          window.removeEventListener('scroll', onScroll);
          document.removeEventListener('mouseout', onExit);
          clearTimeout(tid);
        };
        var lanzar = function () {
          if (lanzado) return;
          var falta = PISO - (Date.now() - T0_VISITA);
          if (falta > 0) {
            clearTimeout(tid);
            tid = setTimeout(lanzar, falta);
            return;
          }
          lanzado = true;
          limpiar();
          abrir();
        };
        var onScroll = function () { if (window.scrollY > 1400) lanzar(); };
        var onExit = function (e) { if (e.clientY <= 0 && (!e.relatedTarget && !e.toElement)) lanzar(); };
        tid = setTimeout(lanzar, 18000);
        window.addEventListener('scroll', onScroll, { passive: true });
        document.addEventListener('mouseout', onExit);
      }
    }
  }
})();